import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import ptCommon from "@/i18n/pt-BR/common.json";
import enCommon from "@/i18n/en-US/common.json";
import ptAuth from "@/i18n/pt-BR/auth.json";
import enAuth from "@/i18n/en-US/auth.json";
import ptLaunches from "@/i18n/pt-BR/launches.json";
import enLaunches from "@/i18n/en-US/launches.json";
import ptSubscription from "@/i18n/pt-BR/subscription.json";
import enSubscription from "@/i18n/en-US/subscription.json";

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "pt-BR",
    supportedLngs: ["pt-BR", "en-US"],
    ns: ["common", "auth", "launches", "subscription"],
    defaultNS: "common",
    interpolation: { escapeValue: false },
    detection: {
      // PT-BR é o idioma padrão do portal: não detectamos o idioma do browser
      // (sem "navigator"), só respeitamos a escolha explícita salva no cookie.
      // Sem cookie → cai no fallbackLng "pt-BR".
      order: ["cookie", "htmlTag"],
      caches: ["cookie"],
      lookupCookie: "imobgo.locale",
      cookieMinutes: 60 * 24 * 365,
    },
    resources: {
      "pt-BR": {
        common: ptCommon,
        auth: ptAuth,
        launches: ptLaunches,
        subscription: ptSubscription,
      },
      "en-US": {
        common: enCommon,
        auth: enAuth,
        launches: enLaunches,
        subscription: enSubscription,
      },
    },
    react: { useSuspense: false },
  });

i18n.on("languageChanged", (lng) => {
  document.documentElement.lang = lng;
});

document.documentElement.lang = i18n.resolvedLanguage ?? "pt-BR";

export default i18n;
